import { useMutation } from '@tanstack/react-query';
import { deleteMe } from '@/api/profile';

export function useDeleteAccount() {
  return useMutation({ mutationFn: deleteMe });
}
